<template>
  <div class="u-wrap">
    <div class="xgsjh-phone">
      <span>当前手机号码</span>
       <span>{{namePrivate(phone)}}</span>
    </div>
    <div class="card">
      <van-form >
        <van-field
          :required="true"
          v-model="model.phone"
          label="联系电话"
          placeholder="请输入手机号码"
          input-align="right"
        />
        <van-field
          :required="true"
          v-model="sms"
          center
          clearable
          label="验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button v-if="senMsg_type==1" size="small" type="primary" @click="sendMsg">{{sendTxt}}</van-button>
            <van-button v-if="senMsg_type==2" size="small" type="primary">{{secodes}}s 重新获取</van-button>
          </template>
        </van-field>
       
      </van-form>
    </div>
    <div class="b-btn">
      <button class="b-button" :disabled="disable" @click="clickSumbit" >提交</button>
    </div>

   
  </div>
</template>

<script>
import { getAction,putAction} from '@/api/manage'
import { isMobile } from '@/utils/validate'
import { WX_USER } from "@/store/mutation-types"
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import Vue from 'vue'
export default {
  mixins: [OpenIdMixin],
  data() {
    return {
      model: {
        phone:'',
      },
      sms:'',
      show:false,
      columns:[],
      senMsg_type:1,
      secodes:60,
      myTimer:null,
      sendTxt:"发送验证码",
      phone:'',
    } 
  },
  created(){
    let object = this.getSmrzData();
    this.phone = object.phone;
  },
  computed: {
  
  disable(){
    let disable = true;
     if(this.model.phone&&this.sms){
      disable =false;
     }

    return disable;
  }

  },
  methods: {
    uploadData(){
        this.model.openId = this.$store.getters.openId || "";
       putAction('sys/detectauth/update', this.model).then((res) => {
            if (res.success) {
              this.sxRzInfo();
              this.$router.replace({ path: '/common/success-xgsjh', query: {phone:this.model.phone}})
            }
          })
    },
    clickSumbit() {
   
      if (!isMobile(this.model.phone)) {
        this.$toast('请输入正确手机号码')
        return
      }
      this.verification().then(res=>{
        this.uploadData();
      })
        
    },
     sendMsg() {
      if (this.model.phone == '') {
        Toast('请输入手机号')
        return
      }
      if (!isMobile(this.model.phone)) {
        this.$toast('请输入正确手机号码')
        return
      }
      let params = {
        sendFlag: true,
        phone: this.model.phone,
      }
      getAction('/sys/mlogin/send/verification', params).then((res) => {
        console.log('res', res)
      })
      this.getSecodes()
    },
    getSecodes() {
      this.secodes = 60
      this.senMsg_type = 2
      this.myTimer = setInterval(() => {
        this.secodes--
        console.log('倒计时', this.secodes)
        if (this.secodes <= 0) {
          this.secodes = 0
          this.senMsg_type = 1
          this.sendTxt = '重新获取'
          console.log('清除倒计时')
          clearInterval(this.myTimer)
        }
      }, 1000)
    },
      verification() {
       return new Promise((resolve, reject) => {
           let params = {
            phone: this.model.phone,
            verificationCode: this.sms,
          }
        getAction('/sys/mlogin/verify/verification', params).then((res) => {
          if (res.success) {
            resolve()
          } else {
            this.$toast(res.message)
            reject()
          }
        })
       })
       
    },

   sxRzInfo(){
      let openId = this.$store.getters.openId
      let params = { openId: openId }
     let url = '/sys/mlogin/wx/login/userinfo';
          getAction(url,params)
          .then(res => {
              if(res.success){
                let obj = res.result;
                if (obj) {
                  let wxInfo = obj.SysUserWechatBind[0];
                   Vue.ls.set(WX_USER, wxInfo);  
                }
              }
        	 })
   },
   namePrivate(str) {
      if (!str) {
        return ''
      }
      let regular = /(\d{3})\d*(\d{4})/
      return str.replace(regular, '$1****$2')
    },
  },
  beforeDestory(){
    clearInterval(this.myTimer)
  }
}
</script>

<style lang="less" scoped>

.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
.u-wrap /deep/ .van-button--primary{
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 120px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}

.xgsjh-phone{
  display: flex;
  padding: 0 12px;
  height: 44px;
  justify-content: space-between;
  align-items: center;
  background: #FFF;
  span{
    font-size: 14px;
    color: #646566;
  }
}
</style>
